/* COOLANDBAG — « Rideau de fer » : rideau entre collections, onglets drops, cartes produit */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- 1. Rideau de fer entre les pages collection ---------- */
  var shutter = document.getElementById('cab-shutter');
  function setShutter(state) { if (shutter) shutter.className = 'cab-shutter' + (state ? ' ' + state : ''); }
  function openShutter() {
    if (!shutter || !/is-closed|is-closing/.test(shutter.className)) return;
    requestAnimationFrame(function () {
      setShutter('is-opening');
      setTimeout(function () { setShutter(''); }, 800);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openShutter); else openShutter();
  window.addEventListener('pageshow', function (e) { if (e.persisted) setShutter(''); });

  function isCollectionLink(url) {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(?:\/[^/]+)?\/?$/i.test(url.pathname);
  }
  document.addEventListener('click', function (e) {
    if (!shutter || reduce || designMode || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download') || a.closest('[data-cab-no-shutter]')) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin || !isCollectionLink(url)) return;
    if (url.pathname === location.pathname) return;
    e.preventDefault();
    var label = (a.getAttribute('data-cab-label') || (a.querySelector('.menu-list__link-title') || a).textContent || '').replace(/\s+/g, ' ').trim();
    if (!label || label.length > 22) label = 'Drop';
    var tag = shutter.querySelector('.cab-shutter__tag');
    if (tag) tag.textContent = label;
    try { sessionStorage.setItem('cabShutter', label); } catch (err) {}
    setShutter('is-closing');
    setTimeout(function () { location.href = url.href; }, 430);
  }, true);

  /* ---------- 2. Ajout au panier (cartes maison) ---------- */
  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; });
    }).then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      var ev = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'cab-drops', data: { itemCount: cart.item_count, source: 'cab-drops', variantId: String(variantId) } } });
      document.dispatchEvent(ev);
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) { try { drawer.open(); } catch (err) {} }
      return cart;
    });
  }

  /* ---------- 3. Cartes maison : couleurs + tailles ---------- */
  function initCard(card) {
    if (card.dataset.cabReady) return;
    var dataEl = card.querySelector('script.cab-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    card.dataset.cabReady = '1';
    var variants = data.variants || [];
    var ci = data.colorIndex, si = data.sizeIndex;
    var ck = ci >= 0 ? 'option' + (ci + 1) : null;
    var sk = si >= 0 ? 'option' + (si + 1) : null;
    var first = variants.find(function (v) { return v.available; }) || variants[0];
    var state = { color: ck && first ? first[ck] : null, size: null };
    var sizeValues = [];
    if (sk) variants.forEach(function (v) { if (sizeValues.indexOf(v[sk]) < 0) sizeValues.push(v[sk]); });
    if (sizeValues.length === 1) state.size = sizeValues[0];
    var img = card.querySelector('.cab-card__media img');
    var sizesBox = card.querySelector('.cab-sizes');
    var msg = card.querySelector('.cab-card__msg');
    var addBtn = card.querySelector('.cab-card__add');
    var quick = card.querySelector('.cab-card__quick');
    var addLabel = addBtn ? addBtn.textContent : '';

    function matches(v) {
      return (!ck || !state.color || v[ck] === state.color) && (!sk || !state.size || v[sk] === state.size);
    }
    function current() {
      var list = variants.filter(matches);
      return list.find(function (v) { return v.available; }) || list[0];
    }
    function renderSizes() {
      if (!sizesBox) return;
      sizesBox.querySelectorAll('button').forEach(function (b) {
        var val = b.getAttribute('data-value');
        var avail = variants.some(function (v) { return v[sk] === val && v.available && (!ck || !state.color || v[ck] === state.color); });
        b.disabled = !avail;
        b.setAttribute('aria-pressed', String(state.size === val && avail));
      });
    }
    function renderSwatches() {
      card.querySelectorAll('.cab-swatch').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-value') === state.color)); });
    }
    function updateImage() {
      if (!img || !ck) return;
      var v = variants.find(function (x) { return x[ck] === state.color && x.image; });
      if (v && v.image && img.getAttribute('src') !== v.image) {
        img.style.opacity = '0.2';
        var pre = new Image();
        pre.onload = pre.onerror = function () { img.src = v.image; img.removeAttribute('srcset'); img.style.opacity = ''; };
        pre.src = v.image;
      }
    }
    function updateCta() {
      if (!addBtn) return;
      var v = current();
      var soldOut = !variants.some(function (x) { return x.available; });
      if (soldOut) { addBtn.disabled = true; addBtn.textContent = 'Épuisé'; if (quick) quick.hidden = true; return; }
      addBtn.disabled = false;
      addBtn.textContent = (sk && state.size && sizeValues.length > 1) ? 'Ajouter — ' + state.size : addLabel;
      if (v && !v.available && state.size) addBtn.textContent = 'Indisponible';
    }
    function say(t) { if (msg) msg.textContent = t || ''; }

    card.addEventListener('click', function (e) {
      var sw = e.target.closest('.cab-swatch');
      if (sw && card.contains(sw)) {
        e.preventDefault();
        state.color = sw.getAttribute('data-value');
        if (state.size && !variants.some(function (v) { return v[ck] === state.color && v[sk] === state.size && v.available; })) state.size = sizeValues.length === 1 ? sizeValues[0] : null;
        say(''); renderSwatches(); renderSizes(); updateImage(); updateCta();
        return;
      }
      var sb = e.target.closest('.cab-sizes button');
      if (sb && card.contains(sb)) {
        e.preventDefault();
        if (sb.disabled) return;
        state.size = sb.getAttribute('data-value');
        say(''); renderSizes(); updateCta();
        return;
      }
      var add = e.target.closest('.cab-card__add, .cab-card__quick');
      if (add && card.contains(add)) {
        e.preventDefault();
        if (sk && !state.size) {
          say('Choisis ta taille');
          card.classList.remove('needs-size'); void card.offsetWidth; card.classList.add('needs-size');
          if (sizesBox) { var fb = sizesBox.querySelector('button:not([disabled])'); if (fb) fb.focus({ preventScroll: true }); }
          return;
        }
        var v = current();
        if (!v || !v.available) { say('Indisponible dans cette sélection'); return; }
        add.disabled = true;
        var before = add.textContent;
        add.textContent = '…';
        addToCart(v.id).then(function () {
          add.textContent = 'Ajouté ✓'; say('');
          setTimeout(function () { add.disabled = false; add.textContent = before; updateCta(); }, 1600);
        }).catch(function (err) {
          add.disabled = false; add.textContent = before; say(err && err.message ? err.message : 'Erreur, réessaie');
        });
      }
    });
    renderSwatches(); renderSizes(); updateCta();
  }

  /* ---------- 4. Onglets drops + rideau de section ---------- */
  function initDrops(root) {
    if (root.dataset.cabReady) return;
    root.dataset.cabReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.cab-tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.cab-panel'));
    var shutterEl = root.querySelector('.cab-stage__shutter');
    var tagEl = root.querySelector('.cab-stage__tag');
    var titleEl = root.querySelector('[data-cab-title]');
    var busy = false;
    function show(i) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (p, k) {
        p.hidden = k !== i;
        if (k === i) {
          p.classList.remove('is-entering'); void p.offsetWidth;
          p.querySelectorAll('.cab-card').forEach(function (c, n) { c.style.animationDelay = (n * 90) + 'ms'; });
          if (!reduce) p.classList.add('is-entering');
          setTimeout(function () { p.classList.remove('is-entering'); }, 1400);
        }
      });
      if (titleEl) titleEl.textContent = tabs[i].getAttribute('data-label');
    }
    function go(i) {
      if (busy || tabs[i].getAttribute('aria-selected') === 'true') return;
      if (reduce || !shutterEl) { show(i); return; }
      busy = true;
      if (tagEl) tagEl.textContent = tabs[i].getAttribute('data-label');
      shutterEl.className = 'cab-stage__shutter is-closing';
      setTimeout(function () {
        show(i);
        shutterEl.className = 'cab-stage__shutter is-opening';
        setTimeout(function () { shutterEl.className = 'cab-stage__shutter'; busy = false; }, 700);
      }, 520);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (n !== null) { e.preventDefault(); tabs[n].focus(); go(n); }
      });
    });
    root.querySelectorAll('.cab-card').forEach(initCard);
  }

  /* ---------- 5. Tailles cliquables sur les cartes Horizon ---------- */
  var cache = {};
  function getProduct(h) {
    cache[h] = cache[h] || fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); });
    return cache[h];
  }
  function sizeIndex(p) {
    return (p.options || []).findIndex(function (o) { return /taille|size|pointure/i.test(typeof o === 'string' ? o : o.name); });
  }
  function buildSizes(card) {
    if (card.dataset.cabSizes) return;
    var content = card.querySelector(':scope > .product-card__content');
    var link = card.querySelector('a.product-card__link[href*="/products/"]');
    if (!content || !link) return;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    card.dataset.cabSizes = '1';
    getProduct(m[1]).then(function (p) {
      if (content.querySelector('.cab-sizes')) return;
      var si = sizeIndex(p);
      if (si < 0) return;
      var key = 'option' + (si + 1), values = [];
      p.variants.forEach(function (v) { if (values.indexOf(v[key]) < 0) values.push(v[key]); });
      if (values.length < 2) return;
      var idInput = content.querySelector('form input[name="id"]');
      function cur() {
        var id = idInput ? Number(idInput.value) : 0;
        return p.variants.find(function (v) { return v.id === id; }) || p.variants.find(function (v) { return v.available; }) || p.variants[0];
      }
      function pick(val) {
        var c = cur();
        var same = p.variants.filter(function (v) { return v[key] === val; });
        var match = same.find(function (v) { return [1, 2, 3].every(function (n) { return n === si + 1 || v['option' + n] === c['option' + n]; }); });
        if (!match || !match.available) match = same.find(function (v) { return v.available; }) || match || same[0];
        return match;
      }
      var box = document.createElement('div');
      box.className = 'cab-sizes';
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', p.options[si].name || 'Taille');
      var chosen = false;
      function render() {
        var c = cur();
        box.innerHTML = '';
        values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = val;
          var avail = p.variants.some(function (v) { return v[key] === val && v.available; });
          if (!avail) b.disabled = true;
          b.setAttribute('aria-pressed', String(!!(chosen && avail && c && c[key] === val)));
          b.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var v = pick(val);
            if (!v) return;
            if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); chosen = true; render(); }
            else window.location.href = p.url + '?variant=' + v.id;
          });
          box.appendChild(b);
        });
      }
      render();
      var bb = content.querySelector(':scope > .buy-buttons-block');
      if (bb) content.insertBefore(box, bb); else content.appendChild(box);
    }).catch(function () { delete card.dataset.cabSizes; });
  }

  function scan(root) {
    var r = root && root.querySelectorAll ? root : document;
    r.querySelectorAll('[data-cab-drops]').forEach(initDrops);
    r.querySelectorAll('.cab-card').forEach(initCard);
    r.querySelectorAll('product-card.product-card').forEach(buildSizes);
  }
  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (mu) {
        mu.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('product-card.product-card')) buildSizes(n);
          else if (n.querySelectorAll) scan(n);
        });
        var t = mu.target;
        if (t && t.closest) {
          var c = t.closest('product-card.product-card');
          if (c && !c.querySelector('.cab-sizes')) { delete c.dataset.cabSizes; buildSizes(c); }
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
